module.exports = __webpack_public_path__ + "img/slide_interno_nopal.32b82095.webp";